import React, { useEffect, useState } from 'react';
import Explore from './Explore/Explore';
import Information from './Information/Information';
import Policy from './Policy/Policy';
import Page from "../../Page/Page";
import SeoHelmet from '../../../Components/SeoHelmet/SeoHelmet';
import LandingPopup from '../../../Components/LandingPopup/LandingPopup';
import { useDispatch, useSelector } from 'react-redux';
import { popupDeActive } from '../../../Redux/Actions/popupAction';

const Home = () => {
    const [popup, setpopup] = useState(false)
    const dispatch = useDispatch()
    const popupHandler = useSelector(state => state.popupHandler)
    const { isUserSaw } = popupHandler

    useEffect(() => {
        function popupStatus() {
            if (isUserSaw === 'false') {
                setTimeout(() => {
                    setpopup(false)
                }, 5000)
            }else{
                setpopup(false)
            }
        }
        popupStatus()
    }, [isUserSaw])

    function closePopUp() {
        dispatch(popupDeActive())
    }
    
    return (
        <Page hideFooter={true}>
            <SeoHelmet title="Elite Partyz - App | The Future App Of Party Planning" keywords="Party, Elite Party, Event, Event manager" description="Elite Partyz is revolutionising the party industry! The original and best double sided party platform. A game changer for party people and suppliers!" canonicalLink="/" />
            <div className="startpage-main">
                {popup && 
                <LandingPopup close={closePopUp} />
                }
                <Explore />
                <Information />
                <Policy />
            </div>
        </Page>
    )
}

export default Home
